<div class="card-block">
  <div class="header main header-padding clearfix">
    Layers
    <capra-icon
      icon="icon-info-outline"
      class="info-icon"
      capraTooltip
      [tooltipContent]="layerInfoTooltip"
      [tooltipInteractive]="false"
      [tooltipDelay]="[750, 0]"
      tooltipPlacement="bottom"
    ></capra-icon>
  </div>
  <mat-accordion multi="false">
    <mat-expansion-panel
      [expanded]="expandedSeries === null"
      (opened)="expandPanel(null)"
      (closed)="closePanel(ALL_LAYERS)"
      hideToggle
    >
      <mat-expansion-panel-header class="all-layers-header">
        All Layers
        <capra-icon class="marks-chevron" [icon]="isPanelOpen(ALL_LAYERS) ? 'icon-chevron-up' : 'icon-chevron-down'">
        </capra-icon>
      </mat-expansion-panel-header>
      <mode-layer-card
        [encoding]="encoding$ | async"
        [model]="model"
        [view]="view$ | async"
        [renderModel]="renderModel$ | async"
        [chartService]="chartService"
        [chartType]="chartType$ | async"
        [queryToken]="queryToken$ | async"
        [queryRunToken]="queryRunToken$ | async"
        [vizToken]="vizToken$ | async"
        [fieldColorMap]="fieldColors$ | async"
        [currentColorPaletteToken]="colorPaletteToken$ | async"
        [fieldFormatMap]="fieldFormats$ | async"
        [format]="format$ | async"
        [isAutoOrManualRender]="isAutoOrManualRender$ | async"
        [binSizeToFieldMap]="binSizeToFieldMap$ | async"
      ></mode-layer-card>
    </mat-expansion-panel>
    <ng-container *ngIf="encoding?.marks.series.length > 1">
      <mat-expansion-panel
        *ngFor="let series of encoding?.marks.series; index as i; trackBy: trackBySeries"
        [expanded]="expandedSeries === series.field"
        (opened)="expandPanel(series.field)"
        (closed)="closePanel(series.field)"
        hideToggle
      >
        <mat-expansion-panel-header>
          <capra-icon
            class="marks-icon"
            [class.warning]="!seriesIsValid[series.field]"
            [icon]="!seriesIsValid[series.field] ? iconWarning : iconMarkMap[series.properties.type.value]"
          ></capra-icon>
          {{ seriesDisplayNames[series.field] }}
          <capra-icon
            class="marks-chevron"
            [icon]="isPanelOpen(series.field) ? 'icon-chevron-up' : 'icon-chevron-down'"
          >
          </capra-icon>
        </mat-expansion-panel-header>
        <mode-layer-card
          [series]="series"
          [encoding]="encoding$ | async"
          [model]="model"
          [view]="view$ | async"
          [renderModel]="renderModel$ | async"
          [chartService]="chartService"
          [chartType]="chartType$ | async"
          [queryToken]="queryToken$ | async"
          [queryRunToken]="queryRunToken$ | async"
          [vizToken]="vizToken$ | async"
          [fieldColorMap]="fieldColors$ | async"
          [currentColorPaletteToken]="colorPaletteToken$ | async"
          [fieldFormatMap]="fieldFormats$ | async"
          [format]="format$ | async"
          [isAutoOrManualRender]="isAutoOrManualRender$ | async"
          [binSizeToFieldMap]="binSizeToFieldMap$ | async"
          (isValid)="onSeriesValidChange($event)"
        ></mode-layer-card>
      </mat-expansion-panel>
    </ng-container>
  </mat-accordion>
</div>
